import { render, staticRenderFns } from "./PointTiers.vue?vue&type=template&id=0ecf982a&scoped=true"
import script from "./PointTiers.vue?vue&type=script&lang=js"
export * from "./PointTiers.vue?vue&type=script&lang=js"
import style0 from "./PointTiers.vue?vue&type=style&index=0&id=0ecf982a&prod&lang=css"
import style1 from "./PointTiers.vue?vue&type=style&index=1&id=0ecf982a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecf982a",
  null
  
)

export default component.exports